import React from 'react';
import BaseCell from './BaseCell';

const formatCellValue = (value, roundUp) => (roundUp ? (Math.round(value * 10000) / 100) : (value * 10000) / 100);

const PercentCell = ({ value, ...props }) => (
  <BaseCell {...props}>
    {value ? `${formatCellValue(value, props.roundUp)}%` : ''}
  </BaseCell>
);

export default PercentCell;
